import React from "react";

import { isGUID } from "@bps/common-utils";
import { Validator } from "@bps/validator";
import { FilterBar } from "@components/filter-bar/FilterBar";
import { Item } from "@components/filter-bar/FilterBar.types";
import { BpIdUsersSearchArgs } from "@libs/api/gateways/bp-id/bp-id.dtos";
import { ValidationMessages } from "@libs/validation/validation-messages.enum";

type IdentityFilterValues = Partial<BpIdUsersSearchArgs>;

interface IdentityFilterProps {
  onFilter: (values: Partial<IdentityFilterValues>) => void;
}

const validator = new Validator<IdentityFilterValues>(validator => ({
  email: validator.string().email({
    message: ValidationMessages.email
  }),
  mobile: validator.string().phone({ message: "Numbers only" }),
  objectId: validator.custom().func<"objectId">(value => {
    if (!value) return undefined;
    return isGUID(value) ? undefined : ValidationMessages.guid;
  })
}));

export const IdentityFilter: React.FC<IdentityFilterProps> = ({ onFilter }) => {
  const items: Item<IdentityFilterValues>[] = [
    {
      name: "profileIdPrefix",
      type: "searchBox",
      stickItem: true,
      props: { placeholder: "Profile Id", removeSpecialCharacters: false }
    },
    {
      name: "objectId",
      type: "searchBox",
      props: { placeholder: "Object Id", removeSpecialCharacters: false }
    },
    {
      name: "givenNamePrefix",
      type: "searchBox",
      props: { placeholder: "Given Name", removeSpecialCharacters: false }
    },
    {
      name: "surnamePrefix",
      type: "searchBox",
      props: { placeholder: "Last Name", removeSpecialCharacters: false }
    },
    {
      name: "email",
      type: "searchBox",
      props: {
        placeholder: "Email",
        removeSpecialCharacters: false
      }
    },
    {
      name: "mobile",
      type: "searchBox",
      props: { placeholder: "Phone", removeSpecialCharacters: false }
    },
    {
      name: "userPrincipalNamePrefix",
      type: "searchBox",
      props: {
        placeholder: "User Principal Name",
        removeSpecialCharacters: false
      }
    }
  ];

  return (
    <FilterBar
      items={items}
      validate={validator.validate}
      onChange={({ state: { values } }) => onFilter(values)}
      maxItemWidth={188}
    />
  );
};
